import React from 'react';
import styles from '../../Accounting.module.css';
import { CheckIcon } from '../../icons';

const FeatureBlocks = () => (
  <>
    <section className={styles.sec} style={{ paddingTop: 0 }}>
      <div className={styles.container}>
        <div className={styles.feature}>
          <div className={`${styles.fText} ${styles.sr}`} data-sr>
            <span className={styles.eyebrow}><span className={styles.dot} />Income &amp; expenses</span>
            <h2>Income and expenses, together.</h2>
            <p>Paid invoices and payments record themselves the moment they clear. Add your other costs by snapping a receipt, or connect your bank account to import and categorize spending automatically — so the whole picture lives in one place.</p>
            <ul className={styles.fList}>
              {['Income auto-recorded with fees & receipts', 'Upload expenses and receipts in seconds', 'Connect your bank to import spending', 'Everything categorized by type and date'].map((t) => (
                <li key={t}><CheckIcon />{t}</li>
              ))}
            </ul>
          </div>
          <div className={`${styles.fVisual} ${styles.sr}`} data-sr>
            <div className={styles.invTop} style={{ border: 'none', paddingBottom: 6 }}>
              <div className={styles.invNum} style={{ fontSize: 14 }}>Recent activity</div>
              <span className={styles.invLab}>INCOME &amp; EXPENSES</span>
            </div>
            <div className={styles.recItem}>
              <span className={`${styles.recDot} ${styles.recDotOn}`} />
              <div className={styles.recFlex}><div className={styles.recName}>Northbeam · #1043</div><div className={styles.recMeta}>Income · Apr 22</div></div>
              <span className={styles.recAmt}>+$1,240</span>
            </div>
            <div className={styles.recItem}>
              <span className={`${styles.recDot} ${styles.recDotOff}`} />
              <div className={styles.recFlex}><div className={styles.recName}>Office supplies</div><div className={styles.recMeta}>Expense · receipt added</div></div>
              <span className={`${styles.recAmt} ${styles.recAmtMuted}`}>-$84.00</span>
            </div>
            <div className={styles.recItem}>
              <span className={`${styles.recDot} ${styles.recDotAccent}`} />
              <div className={styles.recFlex}><div className={styles.recName}>Chase ··1842</div><div className={styles.recMeta}>Bank connected</div></div>
              <span className={`${styles.recAmt} ${styles.recAmtAccent}`}>Synced</span>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section className={styles.sec} style={{ paddingTop: 0 }}>
      <div className={styles.container}>
        <div className={`${styles.feature} ${styles.featureFlip}`}>
          <div className={`${styles.fText} ${styles.sr}`} data-sr>
            <span className={styles.eyebrow}><span className={styles.dot} />Clarity</span>
            <h2>Always know where you stand.</h2>
            <p>See what you&apos;ve collected, what you&apos;ve spent, and what&apos;s still outstanding — for the month, quarter, or year. Income minus expenses, so you always know your real profit.</p>
            <ul className={styles.fList}>
              {['Collected vs. outstanding at a glance', 'Income minus expenses = real profit', 'Month, quarter, and year views', 'Breakdown by client and category'].map((t) => (
                <li key={t}><CheckIcon />{t}</li>
              ))}
            </ul>
          </div>
          <div className={`${styles.fVisual} ${styles.sr}`} data-sr>
            <div className={styles.invTop}>
              <div><div className={styles.invLab}>SUMMARY</div><div className={styles.invNum}>Q2 2026</div></div>
              <span className={styles.invStatus}>Live</span>
            </div>
            <div className={styles.invRow}><span>Collected</span><span className={styles.mono}>$52,180</span></div>
            <div className={styles.invRow}><span>Expenses</span><span className={styles.mono}>$9,310</span></div>
            <div className={styles.invRow}><span>Outstanding</span><span className={styles.mono}>$7,940</span></div>
            <div className={styles.invTotal}><span>Net profit</span><span className={styles.mono}>$42,870</span></div>
          </div>
        </div>
      </div>
    </section>

    <section className={styles.sec} style={{ paddingTop: 0 }}>
      <div className={styles.container}>
        <div className={styles.feature}>
          <div className={`${styles.fText} ${styles.sr}`} data-sr>
            <span className={styles.eyebrow}><span className={styles.dot} />AI tax prep</span>
            <h2>AI gets you tax-ready.</h2>
            <p>Fyntiq&apos;s AI sorts your income and expenses into the right categories, flags likely deductions, and assembles a clean year-end summary — so when it&apos;s time to file, the hard part is already done. Export it or hand it to your accountant.</p>
            <ul className={styles.fList}>
              {['AI categorizes income & expenses', 'Flags likely deductions to review', 'Year-end summary, assembled for you', 'Export to CSV or PDF, or share with your accountant'].map((t) => (
                <li key={t}><CheckIcon />{t}</li>
              ))}
            </ul>
          </div>
          <div className={`${styles.fVisual} ${styles.sr}`} data-sr>
            <div className={styles.invTop} style={{ border: 'none', paddingBottom: 6 }}>
              <div className={styles.invNum} style={{ fontSize: 14 }}>AI summary</div>
              <span className={styles.invLab}>2026</span>
            </div>
            {[
              ['Income & expenses', 'Categorized'],
              ['Likely deductions', 'Flagged to review'],
              ['Year-end summary', 'Ready to export'],
            ].map(([name, meta]) => (
              <div key={name} className={styles.recItem}>
                <span className={`${styles.recDot} ${styles.recDotOn}`} />
                <div className={styles.recFlex}><div className={styles.recName}>{name}</div><div className={styles.recMeta}>{meta}</div></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  </>
);

export default FeatureBlocks;
